// Vendor
import 'bootstrap-datepicker'
import moment from 'moment'
import escapeHtml from '../../utils/sanitize'
import { trans, READ, UNREAD, CLOSED, ARCHIVED_1, ISSUE, CHECKLIST, NOTE, ACTIVE, COMPLETE, FILTER_SUMMARY_MORE } from '../../translator'

// Filtering Flow Functions
function buildPostJson (data) {
  const postJson = {
    criteria: data
  }

  return JSON.stringify(postJson)
}

function fetchResults (data, filterSetKeyPrefix, enabledSuccessHandle = true) {
  postFilters(refreshPath, filters, filterSetKeyPrefix, function (results) {
    if (enabledSuccessHandle) {
      handleFilterResponse(results)
      localStorage.setItem(filterSetKeyPrefix + '_filters', JSON.stringify(filters))
      const event = new Event('FilterResultsUpdated')
      document.dispatchEvent(event)
    }
  })
}

/**
 * @param results
 */
function handleFilterResponse (results) {
  if (results.redirect != undefined) {
    window.location.href = results.redirect
  }

  $('.resultsContainer').html(results.results)
  $('.paginationContainer').each(function () {
    $(this).html(results.pagination)
  })

  if (results.modals) {
    $('#raven-eye-modals-container').html(results.modals)
  }

  $('.resultsContainer').css('opacity', '1')
  $('.paginationContainer').each(function () {
    $(this).css('opacity', '1')
  })

  updateUIFilters()

  if (results.isPageOutOfRangeReload) {
    $('#page-out-of-range-reload').removeClass('d-none')
  }
}

function updateUIFilters () {
  Object.keys(filters).map(key => {
    if (key.includes('_filters')) {
      const filterLogsArray = filters[key].logs ? Object.keys(filters[key].logs) : []

      let filterPermissionGroupList = ''
      if (filters[key].permission_groups) {
        filterPermissionGroupList = Object.keys(filters[key].permission_groups).join(', ')
      }

      let filterTeamList = ''
      if (filters[key].teams) {
        filterTeamList = Object.keys(filters[key].teams).join(', ')
      }

      let filterPrioritiesList = ''
      if (filters[key].priorities) {
        filterPrioritiesList = Object.keys(filters[key].priorities).join(', ')
      }

      let filterCategoriesList = ''
      if (filters[key].categories) {
        filterCategoriesList = Object.keys(filters[key].categories).join(', ')
      }

      let filterResolutionsList = ''
      if (filters[key].resolutions) {
        filterResolutionsList = Object.keys(filters[key].resolutions).join(', ')
      }

      let filterLocationsList = ''
      if (filters[key].locations) {
        filterLocationsList = Object.keys(filters[key].locations).join(', ')
      }

      let filterRecordType = ''
      if (filters[key].record_type) {
        filterRecordType = filters[key].record_type
      }

      let filterIssueStatusesList = ''
      if (filters[key].issue_statuses) {
        filterIssueStatusesList = Object.keys(filters[key].issue_statuses).join(', ')
      }

      let filterSMSThreadStatusList = ''
      const translationMap = {
        Read: READ,
        Unread: UNREAD,
        Closed: CLOSED,
        Archived: ARCHIVED_1
      }
      if (filters[key].sms_thread_status) {
        filterSMSThreadStatusList =
          Object
            .keys(filters[key].sms_thread_status)
            .filter(smsStatus => Object.keys(translationMap).indexOf(smsStatus) !== -1)
            .map(smsStatus => trans(translationMap[smsStatus], {}, 'sms'))
            .join(', ')
      }

      const filterHideDisabled = filters[key].hide_disabled

      if (filterIssueStatusesList != '') {
        $('#issue-status-filterContainer').fadeIn()
        $('#issue-status-filterValues').html(escapeHtml(filterIssueStatusesList))
      } else {
        $('#issue-status-filterContainer').fadeOut()
      }

      // Record Status Filtering
      const filterActiveStatuses = filters[key].active_status
      const filterInActiveStatuses = filters[key].inactive_status

      if (filterActiveStatuses && filterInActiveStatuses) {
        $('#status-filterContainer').fadeIn()
        $('#status-filterValues').html(`${trans(ACTIVE, {}, 'states')}, ${trans(COMPLETE, {}, 'states')}`)
      } else if (filterActiveStatuses) {
        $('#status-filterContainer').fadeIn()
        $('#status-filterValues').html(trans(ACTIVE, {}, 'states'))
      } else if (filterInActiveStatuses) {
        $('#status-filterContainer').fadeIn()
        $('#status-filterValues').html(trans(COMPLETE, {}, 'states'))
      } else {
        $('#status-filterContainer').fadeOut()
      }

      const filterShowIncompleteOnly = filters[key].show_incomplete_only
      let filterFromDate = ''
      let filterToDate = ''

      if (filters[key].from_date != '' && filters[key].from_date != undefined) {
        filterFromDate = moment.unix(filters[key].from_date).format(accountDateFormat.toUpperCase())
      }

      if (filters[key].to_date != '' && filters[key].to_date != undefined) {
        filterToDate = moment.unix(filters[key].to_date).format(accountDateFormat.toUpperCase())
      }

      // Keep maxVisible in sync with the |slice(0, 2) in
      // app/templates/records/components/table/container.html.twig so the
      // banner renders the same on server load and after a filter change.
      const maxVisible = 2
      const $logsContainer = $('#logs-filterContainer')
      if (filterLogsArray.length > 0) {
        const visible = filterLogsArray.slice(0, maxVisible).join(', ')
        const extra = filterLogsArray.length - maxVisible
        const display = extra > 0
          ? visible + ' ' + trans(FILTER_SUMMARY_MORE, { '%count%': extra }, 'filters')
          : visible
        $logsContainer.fadeIn()
        $logsContainer.attr('title', filterLogsArray.join(', '))
        $('#logs-filterValues').html(escapeHtml(display))
      } else {
        $logsContainer.fadeOut()
        $logsContainer.removeAttr('title')
      }

      if (filterPermissionGroupList != '') {
        $('#permission_groups-filterContainer').fadeIn()
        $('#permission_groups-filterValues').html(escapeHtml(filterPermissionGroupList))
      } else {
        $('#permission_groups-filterContainer').fadeOut()
      }

      if (filterTeamList != '') {
        $('#teams-filterContainer').fadeIn()
        $('#teams-filterValues').html(escapeHtml(filterTeamList))
      } else {
        $('#teams-filterContainer').fadeOut()
      }

      if (filterPrioritiesList != '') {
        $('#priorities-filterContainer').fadeIn()
        $('#priorities-filterValues').html(escapeHtml(filterPrioritiesList))
      } else {
        $('#priorities-filterContainer').fadeOut()
      }

      if (filterCategoriesList != '') {
        $('#categories-filterContainer').fadeIn()
        $('#categories-filterValues').html(escapeHtml(filterCategoriesList))
      } else {
        $('#categories-filterContainer').fadeOut()
      }

      if (filterResolutionsList != '') {
        $('#resolutions-filterContainer').fadeIn()
        $('#resolutions-filterValues').html(escapeHtml(filterResolutionsList))
      } else {
        $('#resolutions-filterContainer').fadeOut()
      }

      if (filterFromDate != '') {
        $('#from-date-filterContainer').fadeIn()
        $('#from-date-filterValues').html(escapeHtml(filterFromDate))
      } else {
        $('#from-date-filterContainer').fadeOut()
      }

      if (filterToDate != '') {
        $('#to-date-filterContainer').fadeIn()
        $('#to-date-filterValues').html(escapeHtml(filterToDate))
      } else {
        $('#to-date-filterContainer').fadeOut()
      }

      if (filterRecordType != '') {
        // eslint is disabled for this map because the key names (strings, what filterRecordType is)
        // match the imported constants (which are translation maps)
        const recordTypeTranslationMap = {
          "ISSUE": ISSUE,           // eslint-disable-line
          "CHECKLIST": CHECKLIST,   // eslint-disable-line
          "NOTE": NOTE              // eslint-disable-line
        }
        $('#record-type-filterContainer').fadeIn()
        $('#record-type-filterValues').html(trans(recordTypeTranslationMap[filterRecordType], {}, 'records'))
      } else {
        $('#record-type-filterContainer').fadeOut()
      }

      if (filterLocationsList != '') {
        $('#locations-filterContainer').fadeIn()
        $('#locations-filterValues').html(escapeHtml(filterLocationsList))
      } else {
        $('#locations-filterContainer').fadeOut()
      }

      if (filterShowIncompleteOnly) {
        $('#show-incomplete-only-filterContainer').fadeIn()
      } else {
        $('#show-incomplete-only-filterContainer').fadeOut()
      }

      if (filterHideDisabled) {
        $('#hide_disabled-filterContainer').fadeIn()
      } else {
        $('#hide_disabled-filterContainer').fadeOut()
      }

      if (filterSMSThreadStatusList != '') {
        $('#sms-thread-status-filterContainer').fadeIn()
        $('#sms-thread-status-filterValues').html(escapeHtml(filterSMSThreadStatusList))
      } else {
        $('#sms-thread-status-filterContainer').fadeOut()
      }
    }
  })

  $('#loadingIcon').hide()
}

function clearAllFilters (postUrl, filterSetKeyPrefix, filters, isActiveFiltering = true) {
  clearLocalFilters(filterSetKeyPrefix)
  clearUIFilters()
  // post cleared filters

  if (isActiveFiltering) {
    fetchResults(
      buildPostJson(filters), filterSetKeyPrefix
    )
  }
}

function clearLocalFilters (filterSetKeyPrefix) {
  $('#from-date').datepicker('clearDates')
  $('#to-date').datepicker('clearDates')

  // Record Based Filters
  filters[filterSetKeyPrefix + '_filters'].from_date = null
  filters[filterSetKeyPrefix + '_filters'].to_date = null
  filters[filterSetKeyPrefix + '_filters'].logs = {}
  filters[filterSetKeyPrefix + '_filters'].record_type = null
  filters[filterSetKeyPrefix + '_filters'].active_status = null
  filters[filterSetKeyPrefix + '_filters'].inactive_status = null

  // issue based filters
  filters[filterSetKeyPrefix + '_filters'].statuses = {}
  filters[filterSetKeyPrefix + '_filters'].priorities = {}
  filters[filterSetKeyPrefix + '_filters'].categories = {}
  filters[filterSetKeyPrefix + '_filters'].locations = {}
  filters[filterSetKeyPrefix + '_filters'].resolutions = {}
  filters[filterSetKeyPrefix + '_filters'].show_incomplete_only = false

  // user based filters
  filters[filterSetKeyPrefix + '_filters'].permission_groups = {}
  filters[filterSetKeyPrefix + '_filters'].sms_thread_status = {}
  filters[filterSetKeyPrefix + '_filters'].teams = {}

  filters[filterSetKeyPrefix + '_search'] = null

  return filters
}

function clearUIFilters () {
  $('#from-date').datepicker('clearDates')
  $('#to-date').datepicker('clearDates')
  if ($('#incomplete-issue-toggle').length > 0) {
    $('#incomplete-issue-toggle').checkbox('set unchecked')
  }

  $('.ui.fluid.multiple.search.selection.dropdown#issue_status').dropdown('clear')
  $('.ui.fluid.multiple.search.selection.dropdown#record_status').dropdown('clear')
  $('.ui.fluid.multiple.search.selection.dropdown#priorities').dropdown('clear')
  $('.ui.fluid.multiple.search.selection.dropdown#logs').dropdown('clear')
  $('.ui.fluid.multiple.search.selection.dropdown#categories').dropdown('clear')
  $('.ui.fluid.multiple.search.selection.dropdown#resolutions').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#record_type').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#permission_groups').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#teams').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#locations').dropdown('clear')
  $('.ui.fluid.search.selection.dropdown#sms_thread_status').dropdown('clear')

  $('.search-input').val('')
}

function postFilters (url, filters, filterSetKeyPrefix, successCallback) {
  $('#loadingIcon').show()
  $('.resultsContainer').css('opacity', '0.1')
  $('.paginationContainer').each(function () {
    $(this).css('opacity', '0.1')
  })

  filters.filter_set_key_prefix = filterSetKeyPrefix

  document.dispatchEvent(new Event('FilterRequestStarted'))
  return $.ajax({
    type: 'POST',
    url,
    data: buildPostJson(filters),

    success: successCallback
  }).always(() => document.dispatchEvent(new Event('FilterRequestFinished')))
}

function handlePageLimit (filterSetKeyPrefix, limit) {
  $('#loadingIcon').show()

  filters[filterSetKeyPrefix + '_filters'].page_limit = parseInt(limit)

  fetchResults(
    buildPostJson(filters), filterSetKeyPrefix
  )
}

function handlePagination (filterSetKeyPrefix, page) {
  $('#loadingIcon').show()

  filters[filterSetKeyPrefix + '_filters'].page = page

  fetchResults(
    buildPostJson(filters), filterSetKeyPrefix
  )
}

export {
  buildPostJson,
  fetchResults,
  handleFilterResponse,
  clearAllFilters,
  clearLocalFilters,
  updateUIFilters,
  postFilters,
  handlePageLimit,
  handlePagination
}
